export const TextInputType = {
    TEXT: "text",
    TIME:"time",
    FILE: "file",
    EMAIL: "email",
    PASSWORD: "password",
    NUMBER: "number",
    CHECKBOX: "checkbox",
    DATEPICKER: "datepicker",
    RADIO: 'radio',
}

export const NumberValueType = {
    INT: "INT",
    DECIMAL: "DECIMAL",
}
